export var STYLES = {
  breakpoint: {
    mobile: 375,
    tablet: 768,
    desktop: 1024,
    desktopXl: 1440
  }
}; // Used for storybook placeholder images

export var IMAGES = {
  HERO_MOBILE: 'https://a.vsstatic.com/company/rewards/v3/rewards-page/hero-bg-sm.png',
  HERO_DESKTOP: 'https://vivid-assets.s3.amazonaws.com/banner/region/regions-desktop.jpg',
  HERO_TABLET: 'https://a.vsstatic.com/custom/homepage/banners/rewards/multi-triangles/l-sub-banner.jpg',
  PERFORMER_HERO_EXTERNAL: 'https://media.vsstatic.com/image/upload/t_performer_hero_image/hero/event/concerts/3-311/311-tickets-1.jpg',
  PRODUCTION_HERO_EXTERNAL: 'https://media.vsstatic.com/image/upload/t_production_hero_image/hero/event/concerts/3-311/311-tickets-1.jpg',
  BROADWAY_TILE: 'https://d1gwnrwaeu7bya.cloudfront.net/mobile/app/theater/hamilton.jpg?dimensions=400x200'
};